export const EXTERNAL_LOCALE = 'external-locale';
